import React from 'react';
import { Heading } from "./Heading";
import { UserList } from "./UserList";

export const Home = () => {
  return (
    <div style={{background:"teal",minHeight:"100vh"}}>
      <Heading />
      <UserList />
    </div>
  )
}
